import React, { useState } from "react";
import GlassCard from "../components/GlassCard"; // adjust path if needed
import { wailistPageContent } from "../data/waitlistPageContent";
import { useCurrentLang } from "../hooks/useCurrentLang";
// TODO: replace with your deployed Google Apps Script Web App URL
const GOOGLE_SHEETS_URL = "https://script.google.com/macros/s/AKfycbwdDu3XIuwVw0NuEMavo3KfNBNCWBYGTJGnrmXq7LFAxl64MNEjRU7xma4ujHRHyJnzdw/exec";

const initialFormState = {
  name: "",
  email: "",
  wantsEmails: true,
  wantsDiscount: true,
};

const WaitlistPage = () => {
  const currentLang = useCurrentLang()
  const [formData, setFormData] = useState(initialFormState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const t = wailistPageContent[currentLang]

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email.trim()) {
      setError("Please enter your email.");
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        wantsEmails: formData.wantsEmails ? "yes" : "no",
        wantsDiscount: formData.wantsDiscount ? "yes" : "no",
        createdAt: new Date().toISOString(),
      };

      await fetch(GOOGLE_SHEETS_URL, {
        method: "POST",
        mode: "no-cors", // Apps Script often needs this
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      setIsSubmitted(true);
      setFormData(initialFormState);
    } catch (err) {
      console.error(err);
      setError(t.error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem 1rem",
        background:
          "linear-gradient( #176B87 0%, #EEF5FF 100%)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "900px",
          display: "grid",
          gridTemplateColumns: "minmax(0, 1.2fr) minmax(0, 1fr)",
          gap: "1.5rem",
        }}
      >
        {/* HERO / VALUE PROP */}
        <GlassCard className="glass-card--hero">
          <div style={{ padding: "2rem" }}>
            <div
              style={{
                fontSize: "0.9rem",
                fontWeight: 500,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                marginBottom: "0.5rem",
                color: "#E0F4FF",
              }}
            >
              {t.hero.title}
            </div>
            <h1
              style={{
                fontSize: "2.2rem",
                lineHeight: 1.15,
                marginBottom: "1rem",
                color: "#E0F4FF",
              }}
            >
              {t.hero.heading}
            </h1>
            <p
              style={{
                fontSize: "1rem",
                lineHeight: 1.5,
                marginBottom: "1.5rem",
                color: "#4c6a7a",
              }}
            >
              {t.hero.description}
            </p>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                color: "#4c6a7a",
                fontSize: "0.95rem",
              }}
            >
              <li>• {t.hero.list1}</li>
              <li>• {t.hero.list2}</li>
              <li>• {t.hero.list3}</li>
            </ul>
          </div>
        </GlassCard>

        {/* FORM / THANK YOU CARD */}
        <GlassCard>
          <div style={{ padding: "2rem" }}>
            {!isSubmitted ? (
              <>
                <h2
                  style={{
                    fontSize: "1.4rem",
                    marginBottom: "0.75rem",
                    color: "#0b1720",
                  }}
                >
                  {t.form.title}
                </h2>
                <p
                  style={{
                    fontSize: "0.95rem",
                    marginBottom: "1.25rem",
                    color: "#4c6a7a",
                  }}
                >
                 {t.form.description}
                </p>

                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: "0.75rem" }}>
                    <label
                      htmlFor="name"
                      style={{
                        display: "block",
                        fontSize: "0.85rem",
                        marginBottom: "0.25rem",
                        color: "#EAF4FF",
                      }}
                    >
                      {t.form.name}
                    </label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder={t.form.calling}
                      style={{
                        width: "100%",
                        padding: "0.6rem 0.75rem",
                        borderRadius: "0.6rem",
                        border: "1px solid rgba(255,255,255,0.3)",
                        background: "rgba(0,0,0,0.15)",
                        color: "#FFFFFF",
                        outline: "none",
                        fontSize: "0.95rem",
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: "0.9rem" }}>
                    <label
                      htmlFor="email"
                      style={{
                        display: "block",
                        fontSize: "0.85rem",
                        marginBottom: "0.25rem",
                        color: "#EAF4FF",
                      }}
                    >
                      Email
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="you@example.com"
                      style={{
                        width: "100%",
                        padding: "0.6rem 0.75rem",
                        borderRadius: "0.6rem",
                        border: "1px solid rgba(255,255,255,0.4)",
                        background: "rgba(0,0,0,0.18)",
                        color: "#FFFFFF",
                        outline: "none",
                        fontSize: "0.95rem",
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.4rem",
                      marginBottom: "1rem",
                      fontSize: "0.85rem",
                      color: "#4c6a7a",
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="checkbox"
                        name="wantsEmails"
                        checked={formData.wantsEmails}
                        onChange={handleChange}
                      />
                      <span>
                        {t.form.get_e}
                      </span>
                    </label>

                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="checkbox"
                        name="wantsDiscount"
                        checked={formData.wantsDiscount}
                        onChange={handleChange}
                      />
                      <span>
                        {t.form.get_d}
                      </span>
                    </label>
                  </div>

                  {error && (
                    <div
                      style={{
                        marginBottom: "0.75rem",
                        fontSize: "0.8rem",
                        color: "#FFB4B4",
                      }}
                    >
                      {error}
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    style={{
                      width: "100%",
                      padding: "0.7rem 1rem",
                      borderRadius: "999px",
                      border: "none",
                      cursor: isSubmitting ? "default" : "pointer",
                      background:
                        "linear-gradient(135deg, #1F8AAA 0%, #EEF5FF 100%)",
                      color: "#0b1720",
                      fontWeight: 600,
                      fontSize: "0.95rem",
                      boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
                    }}
                  >
                    {isSubmitting ? t.joining1 : t.joining2}
                  </button>

                  <p
                    style={{
                      marginTop: "0.6rem",
                      fontSize: "0.75rem",
                      color: "var(--text-muted)",
                      lineHeight: 1.4,
                    }}
                  >
                    {t.form.warning}
                  </p>
                </form>
              </>
            ) : (
              <div>
                <h2
                  style={{
                    fontSize: "1.4rem",
                    marginBottom: "0.75rem",
                    color: "#FFFFFF",
                  }}
                >
                  {t.on_list}
                </h2>
                <p
                  style={{
                    fontSize: "0.95rem",
                    marginBottom: "0.75rem",
                    color: "#E2ECF5",
                  }}
                >
                  {t.thanks}
                </p>
                <p
                  style={{
                    fontSize: "0.9rem",
                    marginBottom: "0.75rem",
                    color: "#E2ECF5",
                  }}
                >
                  {t.add_info}
                </p>
                <button
                  type="button"
                  onClick={() => setIsSubmitted(false)}
                  style={{
                    marginTop: "0.5rem",
                    padding: "0.6rem 1.2rem",
                    borderRadius: "999px",
                    border: "1px solid rgba(255,255,255,0.5)",
                    background: "transparent",
                    color: "#FFFFFF",
                    cursor: "pointer",
                    fontSize: "0.9rem",
                  }}
                >
                  {t.add_o_e}
                </button>
              </div>
            )}
          </div>
        </GlassCard>
      </div>
    </div>
  );
};

export default WaitlistPage;
